module.exports = __webpack_public_path__ + "images/feature/140903_wechat_3-57e1ffc38671cb300debceceb1fd522c.jpg";